import { Title } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import Section from '~/App/shared/components/Layout/Section';
import Link from '~/App/shared/components/Link';
import { useTranslation } from '~/Locale';

const StyledTitle = styled(Title)`
  text-align: center;
  padding: 10rem 0;
`;

const BlogError = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <StyledTitle>
        {t(`Couldn't find what you are looking for.`)}{' '}
        <Link to="/ROUTES.BLOG">{t(`Go back to the blog`)}</Link>.
      </StyledTitle>
    </Section>
  );
};

export default BlogError;
